import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, Tooltip } from '@material-ui/core';
import CodeIcon from '@material-ui/icons/Code';
import StorageIcon from '@material-ui/icons/Storage';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginRight: '16px',
        padding: '4px 12px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
    },
    title: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#333',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginRight: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: '4px 8px',
        borderRadius: '4px',
    },
    chip: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        color: '#000',
        fontWeight: 500,
        fontSize: '12px',
        height: '28px',
        '& .MuiChip-icon': {
            color: '#333',
        },
    },
    beChip: {
        backgroundColor: 'rgba(76, 175, 80, 0.5)',
        '& .MuiChip-icon': {
            color: '#2e7d32',
        },
    },
    feChip: {
        backgroundColor: 'rgba(33, 150, 243, 0.5)',
        '& .MuiChip-icon': {
            color: '#1565c0',
        },
    },
});

// Team members for rotation
const BE_TEAM = ['Aneri', 'Nikhil', 'Aditya'];
const FE_TEAM = ['Kishor', 'Tushar', 'Himanshu'];

// Get the current week number of the year
const getWeekNumber = (date: Date): number => {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date.getTime() - startOfYear.getTime()) / 86400000;
    return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
};

// Get current support person based on week rotation
const getCurrentSupport = (team: string[], weekNumber: number): string => {
    const index = (weekNumber - 1) % team.length;
    return team[index];
};

const SupportRota: React.FC = () => {
    const classes = useStyles();
    const [weekOffset, setWeekOffset] = React.useState(0);
    
    const currentWeek = getWeekNumber(new Date()) + weekOffset;
    const currentYear = new Date().getFullYear();
    
    const beSupport = getCurrentSupport(BE_TEAM, currentWeek);
    const feSupport = getCurrentSupport(FE_TEAM, currentWeek);

    const handleClick = () => {
        // Cycle through: current week -> +1 -> +2 -> back to current
        setWeekOffset((prev) => (prev + 1) % 3);
    };

    const weekLabel = weekOffset === 0 ? 'This Week' : weekOffset === 1 ? 'Next Week' : 'Week +2';
    const tooltipTitle = `${weekLabel} (Week ${currentWeek} of ${currentYear}) - Click to preview next weeks`;

    return (
        <Tooltip title={tooltipTitle} arrow>
            <div className={classes.container} onClick={handleClick} style={{ cursor: 'pointer' }}>
                <span className={classes.title}>Support Rota</span>
                <Chip
                    icon={<StorageIcon style={{ fontSize: 16 }} />}
                    label={`BE: ${beSupport}`}
                    className={`${classes.chip} ${classes.beChip}`}
                    size="small"
                />
                <Chip
                    icon={<CodeIcon style={{ fontSize: 16 }} />}
                    label={`FE: ${feSupport}`}
                    className={`${classes.chip} ${classes.feChip}`}
                    size="small"
                />
            </div>
        </Tooltip>
    );
};

export default SupportRota;
